var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"p1"},[_c('img',{attrs:{"src":require("../assets/rocket.png"),"alt":""}}),_c('div',[_vm._v("敬请期待...")])])])
}]

export { render, staticRenderFns }